import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatLength, LENGTH_UNITS } from '@dotloomjs/sdk';
import { useSyncExternalStore } from 'react';
import { useAutosaveState, useEditor, useEditorState, usePointer } from '../context.js';
import { useT } from '../i18n.js';
function Cursor(props) {
    // Only this component re-renders on pointer moves.
    const p = usePointer();
    const t = useT();
    if (!p.world)
        return _jsx("span", { "aria-hidden": "true", style: { minWidth: 180 } });
    return (_jsxs("span", { style: { minWidth: 180, fontVariantNumeric: 'tabular-nums' }, children: [formatLength(p.world[0], props.unit), ", ", formatLength(p.world[1], props.unit), p.snap && (_jsxs("span", { className: "dl-badge", children: [' ', t('status.snap'), ": ", p.snap.kind] }))] }));
}
function Zoom() {
    const { canvas, viewport } = useEditor();
    const subscribe = (cb) => (canvas ? canvas.on('camera', cb) : () => undefined);
    const scale = useSyncExternalStore(subscribe, () => viewport.camera.scale);
    return _jsxs("span", { title: "CSS px per mm", children: [Math.round(scale * 100), "%"] });
}
/** Prompt, typed value, cursor position, toggles, solving/autosave state. */
export function StatusBar(props) {
    const { core } = useEditor();
    const t = useT();
    const prompt = useEditorState((s) => s.prompt);
    const input = useEditorState((s) => s.input);
    const busy = useEditorState((s) => s.busy);
    const snap = useEditorState((s) => s.snapEnabled);
    const grid = useEditorState((s) => s.gridVisible);
    const save = useAutosaveState();
    const sym = LENGTH_UNITS[props.unit].symbol;
    return (_jsxs("footer", { className: "dl-statusbar", children: [_jsx("span", { className: "dl-prompt", role: "status", "aria-live": "polite", children: prompt ? t(prompt) : '' }), input && (_jsxs("span", { className: "dl-badge", children: [_jsxs("span", { className: "dl-visually-hidden", children: [t('status.input'), ": "] }), input, " ", sym] })), busy && (_jsxs("span", { role: "status", children: [t('status.busy'), ' ', _jsx("button", { type: "button", className: "dl-btn", onClick: () => core.cancelSolve(), children: t('status.cancel') })] })), _jsx(Cursor, { unit: props.unit }), _jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: snap, onChange: () => void core.run('toggleSnap') }), " ", t('status.snap')] }), _jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: grid, onChange: () => void core.run('toggleGrid') }), " ", t('status.grid')] }), _jsx(Zoom, {}), save?.error && (_jsx("span", { role: "alert", className: "dl-error", children: t('status.autosaveFailed', { message: save.error }) })), save && (_jsx("span", { children: save.saving || save.pending
                    ? t('status.saving')
                    : save.dirty
                        ? save.lastSavedAt
                            ? t('status.autosaved', { time: new Date(save.lastSavedAt).toLocaleTimeString() })
                            : t('status.unsaved')
                        : t('status.saved') }))] }));
}
//# sourceMappingURL=StatusBar.js.map